/**
 * Only iframe mode may retry a backend 401 with a newly requested user token.
 *
 * ReactKeycloakProvider owns standalone token refresh. Retrying every backend
 * 401 by forcing Keycloak to refresh can turn unrelated backend authentication
 * failures into an endless SSO redirect loop.
 */
export function shouldRetryWithParentToken(status, parentAuth) {
  return status === 401 && Boolean(parentAuth);
}
